
import React from 'react';
import { useDevice } from '@/hooks/use-device';
import { cn } from '@/lib/utils';

interface ResponsiveLayoutProviderProps {
  children: React.ReactNode;
  className?: string;
}

export function ResponsiveLayoutProvider({ 
  children,
  className 
}: ResponsiveLayoutProviderProps) {
  const { isMobile, isTablet, isSafari } = useDevice();

  return (
    <div className={cn(
      "min-h-screen w-full transition-all duration-300",
      "flex flex-col",
      isMobile && "safe-area-inset touch-manipulation",
      isTablet && "tablet-optimized",
      isSafari && "safari-specific-fixes",
      className
    )}>
      {children}
    </div>
  );
}
